import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=5662ae7e&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=5662ae7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662ae7e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SkeletonSlug: require('/app/components/SkeletonSlug.vue').default})
